export enum NOTIFICATIONS_PRIORITY {
  URGENT = "urgent",
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "LOW",
}
export type NotificationCategory =
  | "system_update"
  | "feature"
  | "maintenance"
  | "security"
  | "status"
  | "action"
  | "alert"
  | "create"
  | "update"
  | "delete"
  | "approval"
  | "assignment"
  | "general";

export enum NOTIFICATIONS_APP_NAME {
  Vehicles = "vehicles",
  Contacts = "contacts",
  Issues = "issues",
  Parts = "parts",
  Purchase_order = "purchase_order",
  Service_entry = "service_entry",
  Vendors = "vendors",
  Work_orders = "work_orders",
  Inspection = "inspection",
  Reminders = "reminders",
  Fuel = "fuel",
  Reports = "reports",
  Inventory = "inventory",
  Billing = "billing",
}

export type INotification = {
  id: string;
  category: NotificationCategory;
  app_name: NOTIFICATIONS_APP_NAME;
  title: string;
  message: string;
  priority: NOTIFICATIONS_PRIORITY;
  status:
    | "scheduled"
    | "pending"
    | "processing"
    | "delivered"
    | "failed"
    | "partially_delivered"
    | "cancelled";
  is_read: boolean;
  created: string;
  read_at: string;
  action_url: string;
  data: string;
};

export type INotificationsParams = Partial<
  Omit<
    INotification,
    "title" | "read_at" | "action_url" | "data" | "message"
  > & {
    search: string;
    created_before: string;
    created_after: string;
    offset: number;
    limit: number;
  }
>;

export type PaginatedNotificationsList = {
  next: null | string;
  count: number;
  results: INotification[];
};
